import { Unisex } from './unisex';
import { Up } from './up';
import { Down } from './down';
import { Settings } from './settings';
import { Bug } from './bug';
import { Wrench } from './wrench';
import { LogOut } from './logout';
import { ArrowLeft } from './arrow-left';
import { Question } from './question';
import { Book } from './book';
import { Email } from './email';
import { Sparks } from './sparks';
import { Glossary } from './glossary';
import { Nationality } from './nationality';
import { Multisex } from './multisex';
import { DatabaseLightning } from './database-lightning';
import { Campaigns } from './campaigns';
import { Microphone } from './microphone';
import { IconSize } from '../titan-icon.component';

export const Variants = {
  Unisex,
  Up,
  Down,
  Settings,
  Bug,
  Wrench,
  LogOut,
  ArrowLeft,
  Question,
  Book,
  Email,
  Sparks,
  Glossary,
  Nationality,
  Multisex,
  DatabaseLightning,
  Campaigns,
  Microphone,
} as const;

export interface VariantProps {
  size: IconSize;
}
